import { useEffect } from "react";

/** Google Tag Manager container for Trade Performance Centre register/login flows. */
export const TRADE_GTM_ID = "GTM-MGXQ9HTL";

const injectTradeGoogleTagManager = (gtmId = TRADE_GTM_ID) => {
  if (typeof window === "undefined" || !gtmId) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const scriptId = `gtm-script-${gtmId}`;
  if (!document.getElementById(scriptId)) {
    const script = document.createElement("script");
    script.id = scriptId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  }

  const noscriptId = `gtm-noscript-${gtmId}`;
  if (!document.getElementById(noscriptId)) {
    const noscript = document.createElement("noscript");
    noscript.id = noscriptId;
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    iframe.title = "Google Tag Manager";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }

  window.dataLayer.push({
    event: "pageview",
    page: `${window.location.pathname}${window.location.search}`,
  });
};

export const useTradeGoogleTagManager = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;
    injectTradeGoogleTagManager(TRADE_GTM_ID);
    return undefined;
  }, [enabled]);
};
